export const de = {
  app: {
    stepCreate: 'Erstelle ein eigenes Quiz',
    stepShare: 'Lade Freunde ein',
    stepPlay: 'Spielen',
    logoS: 'Tippe auf S',
  },
  footer: {
    privacy: 'Datenschutz',
    terms: 'Nutzungsbedingungen',
    refunds: 'Rückerstattungen',
    support: 'Support',
    pricing: 'Preise',
    x: 'X',
    instagram: 'Instagram',
  },
  billing: {
    title: 'Tarife & Abrechnung',
    subtitle: 'Einem Quiz beizutreten ist immer kostenlos. Abonniere, um mehr Quizze zu erstellen.',
    planFree: 'Free',
    planBasic: 'Basic',
    planPremium: 'Premium',
    freeIncludes: '{n} Quizze zum Ausprobieren — dauerhaft',
    quizzesPerMonth: '{n} Quizze pro Monat',
    perMonth: '/Monat',
    currentPlan: 'Dein aktueller Tarif',
    subscribe: 'Abonnieren',
    manage: 'Abo verwalten',
    remainingMonthly: 'Noch {n} von {limit} Quizzen diesen Monat',
    remainingFree: 'Noch {n} von {limit} Gratis-Quizzen',
    paymentSuccess: 'Zahlung erfolgreich! Dein Tarif ist jetzt aktiv.',
    paymentActivating: 'Zahlung eingegangen — Tarif wird aktiviert…',
    paymentCancelled: 'Zahlung abgebrochen. Es wurde nichts abgebucht.',
    signInFirst: 'Melde dich mit Google an, um zu abonnieren.',
    checkoutError: 'Zahlung konnte nicht gestartet werden. Bitte erneut versuchen.',
    backHome: 'Zur Startseite',
    quotaExceededTitle: 'Deine Quizze sind aufgebraucht',
    quotaExceededBody: 'Führe ein Upgrade durch, um weiter Quizze zu erstellen. Mitspielen bleibt kostenlos.',
    seePlans: 'Tarife ansehen',
    rematchQuotaExceeded: 'Das gleiche Quiz wird erneut gespielt — das Limit des Gastgebers ist aufgebraucht.',
  },
  auth: {
    signInTitle: 'Melde dich an, um dein Quiz zu erstellen',
    signInHint: 'Nur der Gastgeber braucht ein Konto. Gäste treten über deinen Einladungslink bei — keine Anmeldung nötig.',
    signInGoogle: 'Mit Google fortfahren',
    signInError: 'Anmeldung fehlgeschlagen. Bitte erneut versuchen.',
    signedInAs: 'Angemeldet als {email}',
    signOut: 'Abmelden',
    downloadIosApp: 'iOS-App herunterladen',
    loading: 'Laden…',
  },
  lang: {
    label: 'Sprache',
    en: 'English',
    ru: 'Русский',
    es: 'Español',
    fr: 'Français',
    de: 'Deutsch',
    ja: '日本語',
    ar: 'العربية',
  },
  setup: {
    title: 'Einrichtung erforderlich, bevor du spielen kannst',
    step1: 'Kopiere .env.local.example nach .env.local',
    step2: 'Trage deine Supabase-URL und den Anon Key ein',
    step3: 'Füge deinen OpenAI-API-Schlüssel hinzu',
    step4: 'Führe supabase/schema.sql im Supabase SQL Editor aus',
    step5: 'Starte den Entwicklungsserver neu',
  },
  create: {
    topic: 'Thema',
    topicPlaceholder: 'z. B. 90er-Cartoons, Wissenschaft, Fußball',
    difficulty: 'Schwierigkeit',
    difficultyEasy: 'Leicht',
    difficultyMedium: 'Mittel',
    difficultyHard: 'Schwer',
    questions: 'Anzahl der Fragen',
    modeTitle: 'Spielmodus',
    modeRegular: 'Jede Antwort zählt',
    modeRegularHint: 'Antworte sofort. Du kannst deine Wahl bis zum Ablauf der Zeit ändern, die nie verkürzt wird — alle, die richtig antworten, punkten. Die Runde endet nur früher, wenn alle geantwortet haben.',
    modeHardcore: 'Nur die erste Antwort zählt',
    modeHardcoreHint: 'Nur die erste richtige Antwort punktet. Deine Antwort wird beim Absenden sofort gesperrt — kein Ändern, und die Sprachantwort hat einen Versuch. Antworten werden über eine synchronisierte Uhr sortiert, daher zählt eine schnellere Verbindung kaum.',
    answerTime: 'Antwortzeit (Sekunden)',
    mcTitle: 'Multiple Choice',
    mcHint: 'Vier Optionen pro Frage — alle wählen, jede richtige Antwort bringt Punkte',
    cameraTitle: 'Spieler-Kameras',
    cameraHint: 'Aus = nur Audio (Mikrofone funktionieren weiter). An = alle teilen Video.',
    submit: 'Quiz erstellen',
    generating: 'Fragen werden generiert',
    errorEmptyTopic: 'Bitte gib ein Thema ein.',
    errorGenerate: 'Fragen konnten nicht generiert werden.',
    errorCreate: 'Spiel konnte nicht in der Datenbank erstellt werden.',
    errorGeneric: 'Etwas ist schiefgelaufen.',
    createdTitle: 'Quiz erstellt',
    createdHint: 'Teile diesen Link mit bis zu 5 Freunden und tritt dann dem Quiz bei.',
    shareLink: 'Teilbarer Link',
    copy: 'Kopieren',
    copied: 'Kopiert',
    enterQuiz: 'Quiz betreten',
    adjustShow: 'Mehr',
    adjustHide: 'Ausblenden',
    browseOpenGames: 'Offene Spiele durchsuchen',
    browseOpenGamesHint: 'Einem Quiz beitreten, das auf Spieler wartet',
    inviteOnlyTitle: 'Nur per Link',
    inviteOnlyHintOn: 'Nur Personen mit deinem Link können beitreten. Nicht in der öffentlichen Liste.',
    inviteOnlyHintOff: 'In „Offene Spiele“ sichtbar, bis du das Quiz startest.',
  },
  rooms: {
    title: 'Offene Spiele',
    empty: 'Gerade keine offenen Spiele.',
    refresh: 'Aktualisieren',
    join: 'Beitreten',
    back: 'Zurück',
    loading: 'Laden…',
    error: 'Offene Spiele konnten nicht geladen werden.',
    players: '{n}/{max}',
    agoMinutes: 'vor {n} Min.',
    agoHours: 'vor {n} Std.',
    agoJustNow: 'Gerade eben',
    modeRegular: 'Jede richtige Antwort zählt',
    modeHardcore: 'Nur die erste Antwort zählt',
    mc: 'Multiple Choice',
    voice: 'Sprache',
  },
  join: {
    title: 'Quiz beitreten',
    hostTitle: 'Du bist der Host',
    subtitle: 'Wähle einen Namen, damit alle deinen Punktestand sehen.',
    namePlaceholder: 'Dein Name',
    button: 'Beitreten',
    joining: 'Beitritt…',
    full: 'Dieses Spiel ist voll (bis zu 6 Spieler).',
    errorEmptyName: 'Bitte gib deinen Namen ein.',
    banned: 'Du kannst diesem Spiel nicht erneut beitreten.',
  },
  lobby: {
    title: 'Lobby',
    players: 'Spieler',
    playersCount: '{n} / {max} Spieler',
    you: 'du',
    host: 'Host',
    shareInvite: 'Teile diesen Link, um Spieler einzuladen (bis zu 6 insgesamt)',
    waitingHost: 'Warten auf den Start durch den Host…',
    needMore: 'Warten auf mindestens einen weiteren Spieler…',
    start: 'Quiz starten',
    removePlayer: 'Entfernen',
    removeConfirm: '{name} aus diesem Spiel entfernen?',
    removeConfirmYes: 'Entfernen',
    removeConfirmNo: 'Abbrechen',
    removeError: 'Spieler konnte nicht entfernt werden.',
    listedPublicly: 'Sichtbar in der Liste, bis du startest.',
  },
  game: {
    joining: 'Spiel wird beigetreten',
    notFound: 'Spiel nicht gefunden',
    notFoundHint: 'Prüfe den Link und versuche es erneut. Wenn du der Host bist, erstelle ein neues Spiel.',
    backHome: 'Zur Startseite',
    removedTitle: 'Du wurdest entfernt',
    removedBody: 'Der Host hat dich aus diesem Spiel entfernt.',
    removedHome: 'Zur Startseite',
    host: 'Host',
    guest: 'Gast',
    live: 'Live',
    offline: 'Offline',
    waitingCamera: 'Warten auf Kamera',
    cameraErrorPermission: 'Kamera/Mikrofon blockiert. Zugriff für diese Seite erlauben, dann hier tippen.',
    cameraErrorInsecure: 'Kamera braucht einen sicheren Link (HTTPS).',
    cameraErrorNotFound: 'Keine Kamera oder kein Mikrofon gefunden. Tippen zum erneuten Versuch.',
    cameraErrorBusy: 'Kamera/Mikrofon von einer anderen App belegt. Tippen zum erneuten Versuch.',
    cameraErrorUnknown: 'Kein Zugriff auf Kamera/Mikrofon. Tippen zum erneuten Versuch.',
    cameraErrorTap: 'Tippen zum Erlauben',
    answering: 'Antwortet',
    topic: 'Thema',
    question: 'Frage',
    stealChance: 'Steh-Chance',
    getReady: 'Mach dich bereit',
    thinkHint: 'Lies die Frage — die Antwort wird für beide gleichzeitig freigeschaltet',
    answerNow: 'Jetzt antworten',
    tileAnswered: 'Geantwortet',
    tileThinking: 'Denkt nach…',
    youAnswering: 'Du antwortest',
    listeningAnswer: 'Antwort wird angehört',
    checkingAnswer: 'Antworten werden geprüft',
    speakNow: 'Jetzt sprechen',
    theySpeaking: 'Sie sprechen',
    secondsLeft: 'Noch {n}s',
    opponentSteal: 'Gegner kann diese stehlen',
    liveAnswer: 'Live-Antwort',
    correctAnswer: 'Richtige Antwort',
    speakAnswerNow: 'Sag jetzt deine Antwort',
    speakHint: 'Beide antworten laut — die erste richtige Antwort gewinnt',
    yourAnswer: 'Deine Antwort',
    startSpeaking: 'Beginne mit deiner Antwort…',
    holdToAnswer: 'Zum Antworten halten',
    recording: 'Aufnahme… loslassen zum Senden',
    listening: 'Höre zu…',
    holdHint: 'Halte die Taste und sage deine Antwort',
    saidNothing: 'Keine Antwort',
    done: 'Fertig',
    doneOptional: 'Jetzt festlegen (optional)',
    autoSubmitHint: 'Deine gesprochene Antwort wird automatisch gespeichert — du musst nichts drücken.',
    answerLockedIn: 'Antwort festgelegt',
    waitingOpponent: 'Warten auf den anderen Spieler…',
    typeYourAnswer: 'Gib deine Antwort unten ein',
    typePlaceholder: 'Oder gib deine Antwort hier ein',
    waitShareLink: 'Teile den Link mit deinem Gegner, um zu starten',
    waitHostStart: 'Warten auf den Start durch den Host',
    bothIn: 'Beide Spieler sind dabei',
    questionsCount: '{n} Fragen',
    modeMc: 'Multiple Choice',
    modeVoice: 'Sag deine Antwort',
    startQuiz: 'Quiz starten',
    youreIn: 'Du bist dabei',
    waitHostStartOverlay: 'Warten auf den Start durch den Host',
    waitOpponent: 'Warten auf deinen Gegner',
    connecting: 'Verbindung zum Spiel',
    pointsMultiplier: '(×{n})',
  },
  buzz: {
    label: 'Buzz',
    tapFirst: 'Tippen, um zuerst zu antworten',
    youBuzzed: 'Du hast gebuzzt, fang an zu sprechen',
    otherAnswering: 'Anderer Spieler antwortet',
    ariaBuzz: 'Buzzen zum Antworten',
    ariaDisabled: 'Buzz nicht verfügbar',
  },
  diag: {
    connected: 'Verbunden',
    connecting: 'Verbindung…',
    micOff: 'Kein Mikrofon erkannt',
    micStalled: 'Kein Audio kommt durch',
    micActive: 'Mikrofon aktiv',
    micIdle: 'Mikrofon stumm',
    cameraOff: 'Keine Kamera',
  },
  ptt: {
    hold: 'Gedrückt halten zum Sprechen',
    talking: 'Sprechen…',
    answerLive: 'Mikro live',
  },
  mc: {
    opponentSteal: 'Gegner kann diese stehlen',
    answerLocked: 'Antwort festgelegt',
    canChange: 'Du kannst noch ändern',
    someoneAnswered: 'Jemand hat geantwortet — {n}s zum Antworten!',
    you: 'Du',
  },
  score: {
    vs: 'VS',
    streak: '{n}er Serie',
    leaderboard: 'Punkte',
    points: 'Pkt.',
  },
  winner: {
    result: 'Ergebnis',
    winner: 'Gewinner',
    winners: 'Gewinner',
    tie: 'Unentschieden',
    finalScores: 'Endstand',
    downloadClips: 'Antwort-Clips herunterladen',
    clipLabel: 'F{n} · {role}-Antwort',
    download: 'Herunterladen',
    rematch: 'Revanche',
    rematchWaiting: 'Warten auf die anderen…',
    waitRematch: 'Warten auf Revanche vom Host',
    exit: 'Beenden',
    discuss: 'Ergebnisse besprechen — Anruf endet in {n}s',
    discussHint: 'Kamera und Mikro sind aus. Rematch für einen neuen Anruf.',
  },
} as const;
